import SeekerShell from "../../../layouts/SeekerShell.vue";
import ChecklistLanding from "../views/index.vue";
import WioaDashboard from "../views/WioaDashboard.vue";
import WioaStatus from "../views/WioaStatus.vue";
import ViewChecklist from "../views/ViewChecklist.vue";
import EligibilityDashboard from "../views/Eligibility.vue";
import {
  StepOne,
  StepTwo,
  StepThree,
  StepFour,
  StepFive,
  StepSix,
  StepSeven,
  StepEight,
  StepNine,
  StepTen,
  StepEleven,
} from "@/modules/wioa/section";

export default [
  {
    path: "/",
    name: "",
    component: SeekerShell,
    // meta: {
    //   requiredRole: process.env.VUE_APP_ROLE_ADMIN || process.env.VUE_APP_ROLE_CASE_WORKER,
    //   requiredModulePermission: ModulePermission.SkillsPassport,
    // },
    children: [
      {
        path: "/checklist-landing",
        name: "ChecklistLanding",
        component: ChecklistLanding,
      },
      {
        path: "/eligibility-dashboard",
        name: "EligibilityDashboard",
        component: EligibilityDashboard,
      },
      {
        path: "/wioa-dashboard",
        name: "WioaDashboard",
        component: WioaDashboard,
      },
      {
        path: "/wioa-status",
        name: "WioaStatus",
        component: WioaStatus,
      },
      {
        path: "/view-checklist",
        name: "ViewChecklist",
        component: ViewChecklist,
      },
      {
        path: "/wioa/complete-checklist/1",
        name: "WioaChecklist",
        component: StepOne,
        title: "WIOA Page 1",
        meta: {
          currentPage: 1,
        },
      },
      {
        path: "/wioa/complete-checklist/2",
        name: "WioaChecklistTwo",
        component: StepTwo,
        title: "WIOA Page 2",
        meta: {
          currentPage: 2,
        },
      },
      {
        path: "/wioa/complete-checklist/3",
        name: "WioaChecklistThree",
        component: StepThree,
        title: "WIOA Page 3",
        meta: {
          currentPage: 3,
        },
      },
      {
        path: "/wioa/complete-checklist/4",
        name: "WioaChecklistFour",
        component: StepFour,
        title: "WIOA Page 4",
        meta: {
          currentPage: 4,
        },
      },
      {
        path: "/wioa/complete-checklist/5",
        name: "WioaChecklistFive",
        component: StepFive,
        title: "WIOA Page 5",
        meta: {
          currentPage: 5,
        },
      },
      {
        path: "/wioa/complete-checklist/6",
        name: "WioaChecklistSix",
        component: StepSix,
        title: "WIOA Page 6",
        meta: {
          currentPage: 6,
        },
      },
      {
        path: "/wioa/complete-checklist/7",
        name: "WioaChecklistSeven",
        component: StepSeven,
        title: "WIOA Page 7",
        meta: {
          currentPage: 7,
        },
      },
      {
        path: "/wioa/complete-checklist/8",
        name: "WioaChecklistEight",
        component: StepEight,
        title: "WIOA Page 8",
        meta: {
          currentPage: 8,
        },
      },
      {
        path: "/wioa/complete-checklist/9",
        name: "WioaChecklistNine",
        component: StepNine,
        title: "WIOA Page 9",
        meta: {
          currentPage: 9,
        },
      },
      {
        path: "/wioa/complete-checklist/10",
        name: "WioaChecklistTen",
        component: StepTen,
        title: "WIOA Page 10",
        meta: {
          currentPage: 10,
        },
      },
      {
        path: "/wioa/complete-checklist/11",
        name: "WioaChecklistEleven",
        component: StepEleven,
        title: "WIOA Page 11",
        meta: {
          currentPage: 11,
        },
      },
    ],
  },
];
